import CryptoJS from "crypto-js";

// // Function to decrypt encrypted data in React.js
// const decryptDataBase64 = (encryptedData, secretKey) => {
//   try {
//     const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
//     const decrypted = bytes.toString(CryptoJS.enc.Utf8);
//     return JSON.parse(decrypted);
//   } catch (error) {
//     console.error("Decryption error (Frontend):", error);
//     return null;
//   }
// };

// export default decryptDataBase64;

const decryptDataBase64 = (encryptedBase64Data, secretKey) => {
  console.log(encryptedBase64Data, secretKey);
  if (!encryptedBase64Data || !secretKey) {
    console.error("Invalid input: Encrypted data or secret key is undefined.");
    return null;
  }

  try {
    const encryptedData = atob(encryptedBase64Data);
    const decrypted = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(
      CryptoJS.enc.Utf8
    );
    return decrypted;
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};

export default decryptDataBase64;
